import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestImageAiDescriptionCreateOrTranslate } from '@shared/dto/+image/image_ai_description/_requests/request_image_ai_description_create_or_translate';
import { DTOImageAiDescription } from '@shared/dto/+image/image_ai_description/dto_image_ai_description';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { is_array_of } from '@shared/utils/utils_array';
import { createAsyncThunkSafe } from '../_base/createAsyncThunkSafe';
import { STATE__images } from './STATE__images';

export const remote_images_ai_description_create = createAsyncThunkSafe<
  DTOImageAiDescription[] | DTO_RESPONSE__error,
  RequestImageAiDescriptionCreateOrTranslate
>(ENUM__network_event_client_to_server.IMAGES_AI_DESCRIPTION_CREATE, async (request: RequestImageAiDescriptionCreateOrTranslate) => {
  return await send_to_server<DTOImageAiDescription[] | DTO_RESPONSE__error>(ENUM__network_event_client_to_server.IMAGES_AI_DESCRIPTION_CREATE, request);
});

export function init_remote_images_ai_description_create(builder: ActionReducerMapBuilder<STATE__images>) {
  builder
    .addCase(remote_images_ai_description_create.pending, (state, action) => {
      state.ai_descriptions_creating_in_progress.add(action.meta.arg.image_id);

      //need to force rerender
      state.ai_descriptions_creating_in_progress = new Set(state.ai_descriptions_creating_in_progress);
    })
    .addCase(remote_images_ai_description_create.rejected, (state, action) => {})
    .addCase(remote_images_ai_description_create.fulfilled, (state, action: PayloadAction<DTOImageAiDescription[]>) => {
      if (typeof action.payload === 'string') {
        state.ai_descriptions_creating_in_progress.delete(action.payload);
      } else if (is_array_of(action.payload, DTOImageAiDescription)) {
        for (let item of action.payload) {
          state.ai_descriptions_creating_in_progress.delete(item.image_id);
        }
      }

      //need to force rerender
      state.ai_descriptions_creating_in_progress = new Set(state.ai_descriptions_creating_in_progress);
    });
}
